export const DEFAULT_ITEMS_COUNT_TO_PRELOAD = 2;
